export default class AdminFinancial {
  static getAdminEarnings (bills) {
    return bills
      .filter (bill => bill.status === 'paid')
      .reduce ((total, bill) => total + parseFloat (bill.amount), 0)
  }

  static getTotalBillEarnings (bills) {
    return bills.reduce ((total, bill) => total + parseFloat (bill.amount), 0)
  }
}
